<template>
  <!-- blog-post-section -->
  <div class="space-medium">
      <div class="container">
          <div class="row">
              <div class="offset-xl-2 col-xl-8 offset-lg-2 col-lg-8 col-md-12 col-sm-12 col-12">
                  <div class="section-title text-center">
                      <!-- section title start-->
                      <h2 class="mb10">Wedding Tips and News</h2>
                      <p> The ultimate wedding guide and tips for wedding couples.</p>
                  </div>
                  <!-- /.section title start-->
              </div>
          </div>
          <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" v-for="post in posts">
                  <div class="post-block">
                      <!-- post vertical block -->
                      <div class="post-img zoomimg">
                          <a href="#"><img :src="post.media_url" alt="" class="img-fluid"></a>
                      </div>
                      <div class="post-content">
                          <h3 class="post-heading"><a href="#" class="post-title">{{ post.title}} </a></h3>
                          <p class="meta">
                              <span class="meta-posted-by">By <a href="#">Admin</a></span>
                              <span class="meta-date">{{ post.post_time | moment("MMM DD, YYYY")}}</span>
                          </p>
                          <p>{{post.abstract}}</p>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                  <a href="https://www.allaboutwedding.com/" class="btn btn-default btn-lg">全部文章</a>
              </div>
          </div>
      </div>
  </div>
  <!-- /.blog-post-section -->
</template>
<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: "LandingArticleList",
  props: {
    msg: String
  },
  data() {
    return {
      posts: []
    };
  },
  mounted() {
    axios({ method: "GET", "url": "https://api.allaboutwedding.com/funmall/post/landing/1" }).then(result => {
      this.posts = result.data.posts;
    }, error => {
      console.error(error);
    });
  }

};
</script>
